import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowClockwise } from "@phosphor-icons/react";

const CHECK_MS = 3 * 60 * 1000;
const scripts = (doc) => [...doc.querySelectorAll("script[src]")].map((s) => new URL(s.getAttribute("src"), window.location.origin).pathname).filter((p) => p.includes("/static/js/")).sort().join("|");

// Detects a newly published version; reloads on the next in-app navigation (no logout, no lost typing) or on click.
export default function UpdateWatcher() {
  const [ready, setReady] = useState(false);
  const loc = useLocation();
  const first = useRef(loc.pathname);
  const current = useRef(scripts(document));

  useEffect(() => {
    const check = async () => {
      if (document.hidden || !current.current) return;
      try {
        const html = await (await fetch(`/index.html?v=${Date.now()}`, { cache: "no-store" })).text();
        const latest = scripts(new DOMParser().parseFromString(html, "text/html"));
        if (latest && latest !== current.current) setReady(true);
      } catch { /* offline: try again later */ }
    };
    const t = setInterval(check, CHECK_MS);
    const onVis = () => { if (!document.hidden) check(); };
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("focus", onVis);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onVis); window.removeEventListener("focus", onVis); };
  }, []);

  useEffect(() => {
    if (ready && loc.pathname !== first.current) { window.location.reload(); }
    first.current = loc.pathname;
  }, [loc.pathname, ready]);

  if (!ready) return null;
  return (
    <div role="status" data-testid="update-available-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 rounded-full bg-neutral-900 text-white text-sm pl-4 pr-1.5 py-1.5 shadow-lg">
      <span>A new version of the CRM is available.</span>
      <button type="button" onClick={() => window.location.reload()} data-testid="update-refresh-btn"
        className="flex items-center gap-1 rounded-full bg-white text-neutral-900 px-3 py-1 font-semibold hover:bg-neutral-200 transition-colors">
        <ArrowClockwise size={14} /> Refresh
      </button>
    </div>
  );
}
